import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from './components/layout';
import Status from './routes/status';
import StageRouter from './stages';

import {useDispatch, useSelector} from "react-redux";
import {updateData, updateStep, updateStore, updateStage} from "./actions/application";

import Welcome from "./stages/organisation/0-welcome";
import CompanyDetails from "./stages/organisation/1-company-details";
import CompanyInformation from "./stages/organisation/2-company-information";
import AddressConfirm from "./stages/organisation/3-address-confirm";
import ContactConfirm from "./stages/organisation/4-contact-information";
import ATOLDetail from "./stages/organisation/5-atol-detail";
import ABTADetail from "./stages/organisation/6-abta-detail";
import TTNGDetail from "./stages/organisation/7-ttng-detail";
import TradingDetail from "./stages/organisation/8-trading-detail";
import ServicesDetail from "./stages/organisation/9-services-detail";
import Comments from "./stages/organisation/10-comments";
import BankWelcome from "./stages/bank/0-welcome";
import BankVerification from "./stages/bank/1-bank-verification";
import CardProcessing from './stages/bank/2-card-processing';
import POSCWelcome from './stages/posc/0-welcome';
import POSCDirectors from './stages/posc/1-directors';
import Director from './stages/director'

import './App.css';

const steps = [
  { name: 'welcome', component: Welcome },
  { name: 'company-details', component: CompanyDetails },
  { name: 'company-information', component: CompanyInformation },
  { name: 'address-confirm', component: AddressConfirm },
  { name: 'contact-confirm', component: ContactConfirm },
  { name: 'atol-detail', component: ATOLDetail },
  { name: 'abta-detail', component: ABTADetail },
  { name: 'ttng-detail', component: TTNGDetail },
  { name: 'trading-detail', component: TradingDetail },
  { name: 'services-detail', component: ServicesDetail },
  { name: 'comments', component: Comments },
  { name: 'bank-welcome', component: BankWelcome },
  { name: 'bank-verification', component: BankVerification },
  { name: 'card-processing', component: CardProcessing },
  { name: 'posc-welcome', component: POSCWelcome },
  { name: 'posc-directors', component: POSCDirectors },
];

function App() {
  const { application } = useSelector((state) => state);

  const dispatch = useDispatch();

  const changeStage = (stage) => {
    dispatch(updateStage(stage));
    nextStep();
  }

  const updateState = (section, data) => {
    dispatch(updateData(section, data));
  };

  const addToStore = (item, data) => {
    dispatch(updateStore(item, data));
  }

  const nextStep = (stepNumber = null, named = null) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    let actualStepNumber = parseInt(stepNumber !== null ? stepNumber : parseInt(application.stepNumber) + 1);

    if (named !== null) {
      Object.keys(steps).forEach((key) => {
        if (steps[key].name === named) {
          actualStepNumber = key;
        }
      });
    }

    dispatch(updateStep(steps[actualStepNumber].name, actualStepNumber));
  }

  const previousStep = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    dispatch(updateStep(steps[application.stepNumber - 1].name, application.stepNumber - 1));
  }

  const getStageRouter = () => (
    <StageRouter
      application={application}
      updateState={updateState}
      addToStore={addToStore}
      previousStep={previousStep}
      nextStep={nextStep}
      changeStage={changeStage}
      steps={steps}
    />
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>

          <Route index element={getStageRouter()} />

          <Route exact path="/:dealID/bank" element={getStageRouter()} />

          <Route exact path="/:dealID/people-with-significant-control" element={getStageRouter()} />

          <Route exact path="/:dealID/director/:contactID" element={<Director />} />

          <Route exact path="/:dealID/status" element={<Status />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
